<template>
    <div v-if="isOpen">
        <div v-for="(conf, index) in configurations">
            <div class="m-1">
                <div class="form-group m-form__group">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                            <span class="mr-3 font-weight-bold">{{ conf.name }}</span>
                            <b-button
                                style="font-size:0.7rem;"
                                size="sm"
                                variant="yokumiru-dark-green"
                                :disabled="inProgressPreview"
                                :href="previewUrl(configurations[index].key)"
                                target="_blank">
                                プレビュー
                            </b-button>
                            <div
                                v-show="inProgressPreview"
                                class="u-loader u-loader--xs vc-loader ml-2">
                            </div>
                        </div>
                        <b-button
                            size="sm"
                            variant="yokumiru-blue"
                            :disabled="inProgress || inProgressPreview"
                            @click="close">
                            一覧に戻る
                        </b-button>
                    </div>
                    <quill-editor
                        :ref="`quillEditor_${conf.key}`"
                        v-model="configurations[index].value"
                        :id="`key-${conf.key}`"
                        :options="editorOption"
                        @blur="storePreview(configurations[index].key, configurations[index].value, 0)"
                        @change="storePreview(configurations[index].key, configurations[index].value)">
                    </quill-editor>
                    <div
                        v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                        class="invalid-feedback d-block mt-1">
                        {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button
                @click="updateConfigurations"
                :disabled="inProgress"
                class="btn btn-yokumiru-orange btn-settings mt-3">
                保存
            </button>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor,
    },

    props: {
        previewBaseUrl: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            isOpen: false,
            configurations: [],
            preview: null,
            errors: {},
            timer: null,
            inProgress: false,
            inProgressPreview: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline'],
                            [{ 'header': [1, 2, 3, 4, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'divider'],
                        ],
                        // @see https://quilljs.com/docs/modules/toolbar/#handlers
                        handlers: {
                            divider: function() {
                                this.quill.format('divider', '-')
                            },
                        },
                    },
                },
                placeholder: 'ここに内容を入力してください',
            },
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },
    },

    created: function () {
        bus.$on('open-mail-edit', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-mail-edit')
    },

    methods: {
        /**
         * 表示
         *
         * @param {object} conf
         */
        open: function (conf) {
            this.configurations = [conf]
            this.preview = conf.value
            this.isOpen = true
        },

        /**
         * 非表示
         */
        close: function () {
            this.configurations = []
            this.preview = null
            this.isOpen = false
            bus.$emit('close-mail-edit')
        },

        /**
         * プレビュー保存
         *
         * @param {string} key
         * @param {string} value
         * @param {number} delay
         */
        storePreview: function (key, value, delay = 1500) {
            clearTimeout(this.timer)

            this.timer = setTimeout(async () => {
                if (this.inProgressPreview) return
                this.inProgressPreview = true

                const endpoint = constants.admin.cms_previews.endpoint.base
                const data = { key: key, html: value }

                await axios.post(endpoint, data)
                    .then(() => {
                        this.preview = value
                    })
                    .catch(() => {
                        console.error('プレビューの保存に失敗しました。')
                    })

                this.inProgressPreview = false
            }, delay)
        },

        /**
         * プレビューURL
         *
         * @param {string} key
         */
        previewUrl: function (key) {
            return `${this.previewBaseUrl}/${key}`
        },

        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.vc-loader {
    width: 16px;
    height: 16px;
}
</style>
